import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/pro-regular-svg-icons';
import { faCommentQuestion } from '@fortawesome/pro-light-svg-icons';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import PersonalInformation from './PersonalInformationForm';
import QuestionForm from './QuestionForm';
import { ITotalFormValue } from './IExpertPlatformSubmitQuestion';
import { submitQuestion } from '../../api/expertPlatform';
import { redirect } from '../../helpers/URIhelper';
import { getAntiForgeryToken } from '../../helpers/helperFunction';
import BreadCrumb from '../../components/Breadcrumbs';
import DefaultLayout from '../../layouts/DefaultLayout';
import Container from '../../components/ui/Container';
import Panel from '../../components/ui/Panel';

const steps = [
  {
    id: 1,
    title: 'Stap 1',
    description: 'Persoonlijke informatie',
  },
  {
    id: 2,
    title: 'Stap 2',
    description: 'Stel de vraag',
  },
];

export const ExpertPlatformSubmitQuestionPage: React.FC = () => {
  const [activeStepId, setActiveStepId] = useState(1);
  const [isCompletedStep, setIsCompletedStep] = useState(false);
  const [forgeryToken, setforgeryToken] = useState<string | null>('');
  const [formValues, setFormValues] = useState<ITotalFormValue>({
    email: '',
    name: '',
    topic: '',
    question: '',
    forgeryToken: null,
  });

  const handleSubmit = async ({
    question,
    topic,
  }: {
    question: string;
    topic: string;
  }): Promise<void> => {
    try {
      await submitQuestion({ ...formValues, topic, question, forgeryToken });
      redirect('/expert/steleenvraag/bedankt');
    } catch (err) {
      throw new Error('Api error');
    }
  };

  useEffect(() => {
    if (activeStepId === 2) {
      setIsCompletedStep(true);
    }
  }, [activeStepId]);

  useEffect(() => {
    const antiForgeryToken: string | null = getAntiForgeryToken();
    if (antiForgeryToken !== null) {
      setforgeryToken(antiForgeryToken);
    }
  }, []);

  const breadcrumbLinks = [
    { name: 'Home', linkTo: '/' },
    { name: 'Expertplatform', linkTo: '/expert' },
    { name: 'Stel een vraag', linkTo: '/expert/steleenvraag' },
  ];

  return (
    <DefaultLayout breadcrumbs={<BreadCrumb links={breadcrumbLinks} />}>
      <Container state="defaultLayoutFirst">
        <Panel position="last" className="lg:w-3/4">
          <div className="flex items-center gap-[16px] mb-[28px]">
            <FontAwesomeIcon
              icon={faCommentQuestion as IconProp}
              color="#4EADF1"
              fontSize={'34'}
            />
            <h1 className="text-blue-900 font-bold font-avantgarde md:text-[28px] md:leading-[42px] text-[18px] leading-[24px]">
              Stel je vraag aan een expert
            </h1>
          </div>

          <div className="flex justify-between items-center">
            {steps?.map((step) => (
              <div
                key={step.id}
                className={
                  activeStepId === 2 && step.id === 1 && isCompletedStep
                    ? 'stepper-state--completed'
                    : `${step.id === activeStepId ? 'stepper-state--current' : 'stepper-state--future'}`
                }
              >
                <h2
                  className="font-black font-body md:text-[24px]
                  md:leading-[32px] text-[16px] leading-[23px]"
                >
                  {step.title}
                  {activeStepId === 2 && step.id === 1 && isCompletedStep && (
                    <FontAwesomeIcon
                      className="ml-3"
                      icon={faCheck as IconProp}
                      color="#7195C0"
                      fontSize="24"
                    />
                  )}
                </h2>
                <h3
                  className={`font-body md:text-[16px]
                  md:leading-[24px] text-[13px] leading-[19.1px] ${step.id === activeStepId ? 'font-bold' : 'font-normal'}`}
                >
                  {step.description}
                </h3>
              </div>
            ))}
          </div>
          <hr className="my-6 md:my-10 w-full border-top border-stone-100" />
          {activeStepId === 1 ? (
            <PersonalInformation
              setActiveStepId={setActiveStepId}
              setFormValues={setFormValues}
              formValues={formValues}
            />
          ) : (
            <QuestionForm
              setActiveStepId={setActiveStepId}
              handleOnSubmit={handleSubmit}
            />
          )}
        </Panel>
      </Container>
    </DefaultLayout>
  );
};

ExpertPlatformSubmitQuestionPage.displayName = "Page:ExpertPlatformSubmitQuestion";

export default ExpertPlatformSubmitQuestionPage;
